/**
 *
 * v.1.0  14/10/24  Inicial
 **/

import React from 'react'
import PropTypes from 'prop-types';
import {Button, FormGroup, TextArea} from "@blueprintjs/core";


class FirmaMail extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            firma: props.firma,
        }
        console.log("Constructor props: ", props);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};

        if (nextProps.firma !== prevState.firma) {
            newState.firma = nextProps.firma;
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }

    onFirmaCambiada= (newFirma) => {
        const {onChange} = this.props;
        this.setState({firma: newFirma}, () => onChange && onChange(newFirma));
    }

    render() {
        const {firma} = this.state;
        const {className, mostrarRender, firmaHeight, titulo, obligatorio} = this.props;
        let style = {
            height: firmaHeight ? firmaHeight : '100px',
        }
        let firmaReal= "<h1>Prueba</h1><h2>Subprueba</h2>";

        console.log("Título: ", titulo);

        return (
            <div className={className}>
                <FormGroup key={"fm"} label= {titulo} labelInfo={ obligatorio ? "*" : ""}>
                    <TextArea
                        style={style}
                        fill={true}
                        growVertically={true}
                        large={true}
                        onChange={(event) => this.onFirmaCambiada(event.target.value)}
                        value={firma}
                    />
                </FormGroup>
                {(Boolean(mostrarRender) && firmaReal ) &&
                    <div dangerouslySetInnerHTML={{__html: firma}} ></div>

                }

            </div>

        );
    }
}


FirmaMail.propTypes = {
    firmaHeight: PropTypes.number,
    mostrarRender: PropTypes.bool,
    titulo: PropTypes.string,
    obligatorio: PropTypes.bool,

    firma: PropTypes.string,
    onChange: PropTypes.func,

}

export default FirmaMail